import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { noHeaderCss } from "../../../sass/Main";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper/index";
import WelcomeForm from "./WelcomeForm";
import PaperHeader from "../PaperHeader";
import { pushMessage } from "../../../redux/actions/commonActions";
import { connect } from "react-redux";

class WelcomeScreen extends React.Component {
  renderErrorMessage = () => {
    const { userUpdateStatus, userUpdateErrorMessage, pushMessage } = this.props;

    if (!userUpdateStatus) {
      return null;
    }

    const errorMessage = userUpdateErrorMessage
      ? userUpdateErrorMessage
      : "There was an error while updating your profile.";

    pushMessage({ type: "error", message: errorMessage });
  };

  render() {
    const { classes } = this.props;

    return (  
     <>
      <PaperHeader heading="Welcome!" text="Let's finish setting up the basics of your profile." /><br/><br/>
      <WelcomeForm />
      {this.renderErrorMessage()}
    </>
    );
  }
}

const WelcomeScreenStyled = withStyles(noHeaderCss)(WelcomeScreen);

const mapStateToProps = state => {
  return {
    userUpdateStatus: state.gettingStartedWizard.userUpdateStatus,
    userUpdateErrorMessage: state.gettingStartedWizard.userUpdateErrorMessage
  };
};

export default connect(
  mapStateToProps,
  { pushMessage }
)(WelcomeScreenStyled);
